import { Component } from '@angular/core';

@Component({
  selector: 'globot-banner',
  template: `
    <div class="container">
      <div class="emojiiBot">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="118"
          height="110"
          viewBox="0 0 118 110"
          fill="none"
        >
          <path
            d="M19.0816 36.153C19.0816 36.153 8.6778 52.0923 19.5246 71.3896C19.5246 71.3896 6.29966 72.8877 0.978117 59.9345C0.978117 59.9345 -3.33004 48.8209 6.13671 40.2245C6.13671 40.2245 10.9185 35.8575 19.0816 36.153Z"
            fill="#DA94FB"
          />
          <path
            d="M103.502 54.2945C103.874 32.7208 84.255 14.8874 59.6807 14.4625C35.1064 14.0376 14.8829 31.182 14.5103 52.7557C14.1378 74.3294 33.7572 92.1628 58.3315 92.5878C82.9058 93.0127 103.129 75.8682 103.502 54.2945Z"
            fill="#7B5CF5"
          />
          <path
            d="M99.5262 37.5781C99.5262 37.5781 109.375 53.869 97.866 72.779C97.866 72.779 111.03 74.7357 116.8 61.9711C116.8 61.9711 121.49 51.0154 112.328 42.098C112.328 42.098 107.705 37.5679 99.5312 37.5832L99.5262 37.5781Z"
            fill="#DA94FB"
          />
          <path
            d="M8.30109 38.7056C8.30109 38.7056 11.8454 36.9629 13.6175 36.6418C13.6175 36.6418 17.2942 7.64241 58.619 6.75576C58.619 6.75576 98.4058 5.86402 104.675 38.1756C104.675 38.1756 108.545 39.1948 109.935 40.377C109.629 36.5858 108.662 30.6086 105.286 24.29C97.4535 9.63991 82.7925 4.6003 77.965 2.94421C69.0635 -0.113193 61.4758 -0.04695 57.519 0.0192937C56.9181 0.029485 47.0694 0.248599 39.2272 2.94421C8.94272 13.8642 8.63719 35.7093 8.30618 38.7056H8.30109Z"
            fill="#27283B"
          />
          <path
            d="M91.6181 54.2535C91.3788 68.1952 76.5956 79.2426 58.5991 78.9318C56.0647 78.888 53.6018 78.6212 51.2411 78.1561L51.5151 78.2846C46.9574 81.449 41.4271 82.9013 35.9019 82.3917C35.3926 82.351 34.9089 82.1675 34.4811 81.8822C34.0584 81.5917 33.7274 81.1993 33.5033 80.7407C33.2793 80.2821 33.1723 79.7776 33.208 79.2681C33.2436 78.7585 33.3964 78.2642 33.6714 77.8413C34.9421 75.8682 35.6868 73.6018 35.8388 71.2601C29.9309 66.5786 26.3301 60.1537 26.4508 53.1222C26.6902 39.1805 41.4733 28.1331 59.4698 28.4439C77.4663 28.7547 91.8574 40.3117 91.6181 54.2535Z"
            fill="#27283B"
          />
          <path
            d="M74.8186 83.2983C75.0987 84.8677 74.0497 86.371 72.4812 86.6461L67.2717 87.5735C65.7032 87.8538 64.201 86.8041 63.926 85.2346C63.6459 83.6652 64.695 82.1619 66.2634 81.8868L71.4729 80.9594C73.0414 80.6791 74.5436 81.7288 74.8186 83.2983Z"
            fill="#27283B"
          />
          <path
            d="M74.416 82.2596C74.416 82.2596 75.1951 83.289 74.6095 84.9909C74.5738 85.0928 74.5891 85.0725 74.5891 85.0725C74.5891 85.0725 95.5239 81.3017 101.879 63.8898C101.879 63.8898 103.32 58.7839 103.32 55.4004C103.32 55.4004 98.2381 76.0429 74.416 82.2596Z"
            fill="#27283B"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M51.8626 56.9554C48.7916 51.4004 42.1277 52.8362 40.5472 56.9362C40.2493 57.7092 39.3811 58.0943 38.6081 57.7963C37.8351 57.4984 37.45 56.6302 37.748 55.8572C40.1999 49.4962 50.1243 47.6105 54.4881 55.5039C54.8889 56.2289 54.6261 57.1416 53.9011 57.5424C53.1761 57.9432 52.2634 57.6804 51.8626 56.9554Z"
            fill="#DA94FB"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M77.4132 56.6507C74.3421 51.0957 67.6782 52.5315 66.0978 56.6315C65.7998 57.4045 64.9316 57.7896 64.1587 57.4916C63.3857 57.1937 63.0006 56.3255 63.2985 55.5525C65.7505 49.1915 75.6749 47.3058 80.0386 55.1992C80.4395 55.9242 80.1767 56.8369 79.4516 57.2377C78.7266 57.6385 77.814 57.3757 77.4132 56.6507Z"
            fill="#DA94FB"
          />
          <path
            opacity="0.48"
            d="M60 110C80.9868 110 98 108.433 98 106.5C98 104.567 80.9868 103 60 103C39.0132 103 22 104.567 22 106.5C22 108.433 39.0132 110 60 110Z"
            fill="#7A82CC"
          />
        </svg>
      </div>
      <div class="content">
        <h4>¡Desbloquea todo el potencial de tu asistente!</h4>
        <p>Suscríbete ahora y no te pierdas la oportunidad de mejorar tu servicio al cliente.</p>
        <button class="btn" (click)="showPlansDialog = true">
          Suscribirse ahora <img src="/assets/icons/crown.svg" alt="crown" />
        </button>
      </div>
    </div>
    <p-dialog
      header="Planes de suscripción"
      [modal]="true"
      [style]="{ width: '70rem' }"
      [(visible)]="showPlansDialog"
      [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
      [resizable]="false"
    >
      <globot-type-subscription-plans></globot-type-subscription-plans>
    </p-dialog>
  `,
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {
  showPlansDialog: boolean = false;
}
